import DOMPurify from 'dompurify'

const AGREEMENT_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'span',
    'strong', 'b', 'em', 'i', 'u',
    'ul', 'ol', 'li',
    'img'
  ],
  ALLOWED_ATTR: [
    'class',
    'src', 'alt', 'title', 'width', 'height',
    'data-tag', 'data-signed-id', 'contenteditable'
  ],
  ALLOW_DATA_ATTR: false
}

const purify = typeof window === 'undefined' ? DOMPurify : DOMPurify(window)

const UNSAFE_URI = /^\s*(?:javascript|vbscript|data):/i
const SAFE_DATA_IMAGE = /^\s*data:image\//i
const ALLOWED_CLASSES = new Set(['dynamic-tag'])

purify.addHook('afterSanitizeAttributes', (node) => {
  if (!node.tagName) return

  if (node.tagName === 'IMG') {
    const src = node.getAttribute('src') || ''
    if (src && UNSAFE_URI.test(src) && !SAFE_DATA_IMAGE.test(src)) {
      node.removeAttribute('src')
    }
  }

  if (node.hasAttribute('class')) {
    const allowed = (node.getAttribute('class') || '')
      .split(/\s+/)
      .filter((cls) => ALLOWED_CLASSES.has(cls))
    if (allowed.length) {
      node.setAttribute('class', allowed.join(' '))
    } else {
      node.removeAttribute('class')
    }
  }
})

export function sanitizeAgreementHtml (html) {
  if (!html) return ''
  return purify.sanitize(String(html), AGREEMENT_SANITIZE_CONFIG)
}

export function isAgreementHtmlEmpty (html) {
  if (!html) return true
  if (/<img\b/i.test(html)) return false

  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .trim()
  return !text
}
